import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { LacertaMetaEffects } from './meta.effects';

@NgModule({
  imports: [EffectsModule.forFeature([LacertaMetaEffects])],
})
export class LacertaMetaNgrxModule {}
